import { IJsonQuery } from '../../../shared/repositories/common/json_query';

export * from '../../../shared/repositories/common/json_query';
export type TJsonQueryKey = keyof Omit<
  IJsonQuery,
  'isWCfixed' | 'all_day_access' | 'all_week_access' | 'amenity' | 'coworking_id'
>;
